'use client';

import React from 'react';
import classNames from 'classnames';
import Button from '@/components/Button/Button';
import ContentfulRichText from '@/components/ContentfulRichText/ContentfulRichText';
import { analytics } from '@/utils/analytics';
import { DescriptionType } from '@/utils/common.types';

interface Props {
  title: string;
  description?: DescriptionType;
  paragraphStyle?: string;
  buttonLabel: string;
  buttonUrl: string;
  buttonOpenNewWindow?: boolean;
  includeSegment?: boolean;
}

const CtaCardSimple = ({
  title,
  description,
  paragraphStyle,
  buttonLabel,
  buttonUrl,
  buttonOpenNewWindow = true,
  includeSegment = false,
}: Props) => {
  return (
    <div>
      <div
        className={classNames({
          ['text-left']: paragraphStyle && paragraphStyle === 'left',
          ['text-center']: paragraphStyle && paragraphStyle !== 'left',
        })}
      >
        <h3 className="mb-[18px] text-[22px] font-bold leading-[1.18] tracking-[-0.35px] text-hbg-blue md:mb-5 md:text-[25px]">
          {title}
        </h3>
        {description && (
          <div className="mb-[18px] text-[18px] text-hbg-blue">
            {ContentfulRichText(description)}
          </div>
        )}
        <Button
          href={buttonUrl}
          openNewWindow={buttonOpenNewWindow}
          label={buttonLabel}
          onClick={() =>
            includeSegment &&
            analytics?.track('CTA Clicked', {
              isNav: true,
              type: 'button',
              text: title,
            })
          }
        />
      </div>
    </div>
  );
};

export default CtaCardSimple;
